module.exports = __webpack_public_path__ + "static/media/ic_directorio.42192970.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/services/ic_directorio.webp
// module id = 171
// module chunks = 1